
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gop4v0EN3DWHPHx0vv_2od1v2Pggq7YKmHW9ollIZqscMeta } from "/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexkb4dQfbUKCmCtSdV8Vd3Snt0KPl9oA77sYIFJnWFcGQMeta } from "/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchg92aBvgg_45kLq9NGVo1_45GJeb0nrZeC93HJVMCCb8yBo0Meta } from "/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexx9ndrramYOlFeWNT0ciXopFsnCH60Fk_5JGhuLiNXG0Meta } from "/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93d1C9mpR0Ru2PrvKsgiX1oywsO5ygAmiJHf_htk1Z5mYMeta } from "/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexxU8_454XXEyxJN41neyaj6PG8FNGSJe4_SYmMElQ9HOEUMeta } from "/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93tT_45eQ30skRwFRWnvCrSxHpMqeGm_wltv1AZVQpAs5RIMeta } from "/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexcnPcng0hGP4hFEwFVBdY8pSGBn8FnCGxjvQzzAHuIJ8Meta } from "/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_932we4g60dC_45w1jmiajICFiXQX5POrWTyU08080tXeH1UMeta } from "/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexL_MbVfmrakeKJY6K74w6jkBbg1Sp_L3qyAn4bZ6RMxoMeta } from "/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexvoUIwzJRrkBpDlhLlMr_X2yWnnzQ9tApV3zMO3rvpWMMeta } from "/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexxU8_454XXEyxJN41neyaj6PG8FNGSJe4_SYmMElQ9HOEUMeta || {},
    component: () => import("/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexcnPcng0hGP4hFEwFVBdY8pSGBn8FnCGxjvQzzAHuIJ8Meta || {},
    component: () => import("/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexL_MbVfmrakeKJY6K74w6jkBbg1Sp_L3qyAn4bZ6RMxoMeta || {},
    component: () => import("/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexvoUIwzJRrkBpDlhLlMr_X2yWnnzQ9tApV3zMO3rvpWMMeta || {},
    component: () => import("/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]